import {
  ApiData,
  Part,
  Customer,
  EmailList,
  Dashboard,
  ReplenishmentView,
  Shipment,
  Navigation,
  PullRequest,
  Notifications,
  PurchaseOrder,
  WindowSize,
} from '@/interfaces'

const initialApiData = {
  isLoading: true,
  hasError: false,
  data: [],
}

// Any state that should be cleared and reset when refreshing data or changing accounts should be
// initialized here. Anything that shouldn't change should be initialized in the store constructor.
export const getResetState = () => ({
  parts: { ...initialApiData } as ApiData<Part[]>,
  customer: {} as Customer,
  accountList: [],
  notifications: {} as Notifications,
  emailList: [] as EmailList[],
  purchaseOrders: { ...initialApiData } as ApiData<PurchaseOrder[]>,
  pullRequests: { ...initialApiData } as ApiData<PullRequest[]>,
  replenishmentView: { ...initialApiData } as ReplenishmentView,
  shipments: { ...initialApiData } as ApiData<Shipment[]>,
  refreshTime: new Date(),
})

export const state = {
  ...getResetState(),
  accountId: '', // note: the selected account should not be reset during a data refresh
  navigation: {
    isVisible: true,
  } as Navigation,
  dashboard: {
    headerVisible: true,
  } as Dashboard,
  currentInventoryView: 'grid',
  currentShipmentsView: 'table',
  currentPullsView: 'table',
  currentPullsHistoryView: 'table',
  currentReplenishmentsView: 'table-product',
  currentSubtabs: [{ parent: 'pulls', subtab: 'pending' }],
  currentBreakpoint: 'xl',
  windowSize: { width: 0, height: 0 } as WindowSize,
  isCSO: false,
  userName: '',
  selectedpart: { isVisible: '' },
}

export default state
